import React from 'react'
import moment from 'moment'
import { COLORES } from '../../../../../config/colores'
import TableValueAction from '../../../../MuiTable/components/TableValueAction'
import OperacionesCupoNominado from '../OperacionesCupoNominado'
import TablaConsultaCodigoDeCupos from '../../consultaCodigoDeCupos/containers/TablaConsultaCodigoDeCupos'

// Constantes para renderizar las columnas del listado de cupos nominados
export function getColumnasCuposNominados (rol) {
  const rolConsulta = rol.find((r) => r === 'EXPORTADOR_CONSULTA')
  const soloConsulta = !!rolConsulta
  const columnas = [
    {
      name: 'fechaDeEmisionDate',
      label: 'Fecha',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        customBodyRender: f => {
          moment.locale('ar-AR')
          const fecha = moment(f).format('DD/MM/YYYY')
          return <div>{fecha}</div>
        },
        setCellProps: () => ({
          style: {
            position: 'sticky',
            left: '0',
            background: COLORES.grey.light,
            zIndex: 100
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            whiteSpace: 'nowrap',
            position: 'sticky',
            left: 0,
            background: 'white',
            zIndex: 101
          }
        })
      }
    },
    {
      name: 'exportador',
      label: 'Exportador',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        display: (rol ? rol[0] !== 'EXPORTADOR' && rol[1] !== 'EXPORTADOR' : false)
      }
    },
    {
      name: 'cargador',
      label: 'Titular de cupo',
      options: {
        filter: true,
        sort: true,
        display: (rol ? rol[0] !== 'CARGADOR' && rol[1] !== 'CARGADOR' : false)
      }
    },
    {
      name: 'corredor',
      label: 'Corredor de cupo',
      options: {
        filter: true,
        sort: true,
        display: (rol ? rol[0] !== 'CORREDOR' && rol[1] !== 'CORREDOR' : false)
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'cupo',
      label: 'Nominados',
      options: {
        filter: true,
        sort: true,
        total: true,
        customBodyRender: (entry) => {
          const value = entry.cantidadAsignada
          const fechaFiltro = entry.fechaDeEmisionDate
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: [entry.claveCereal]
            },
            {
              name: 'fechaCupo',
              filterList: [fechaFiltro]
            },
            {
              name: 'exportador',
              filterList: [entry.exportador]
            },
            {
              name: 'cargador',
              filterList: [entry.cargador]
            },
            {
              name: 'corredor',
              filterList: [entry.corredor]
            }
          ]

          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Códigos de cupo nominados'
                content={<TablaConsultaCodigoDeCupos
                  showTitle={false}
                  filtroInicial={filtroInicial}
                  fechaFiltro={fechaFiltro}
                />
                }
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'activadosEnAfip',
      label: 'Activados en ARCA',
      options: {
        filter: false,
        sort: true,
        total: true
      }
    },
    {
      name: 'cantidadUsada',
      label: 'En terminal',
      options: {
        filter: false,
        sort: true,
        total: true
      }
    },
    {
      name: 'cupo',
      label: 'Editables',
      options: {
        filter: false,
        sort: true,
        total: true,
        customBodyRender: (entry) => {
          const value = entry.cantidadDisponible
          const fechaFiltro = entry.fechaDeEmisionDate
          const filtroInicial = [
            {
              name: 'cereal',
              filterList: [entry.claveCereal]
            },
            {
              name: 'fechaCupo',
              filterList: [fechaFiltro]
            },
            {
              name: 'exportador',
              filterList: [entry.exportador]
            },
            {
              name: 'cargador',
              filterList: [entry.cargador]
            },
            {
              name: 'corredor',
              filterList: [entry.corredor]
            },
            {
              name: 'estadoArribo',
              filterList: ['']
            }
          ]

          return (
            (value > 0)
              ? <TableValueAction
                value={value}
                title='Códigos de cupo disponibles para Renominar'
                content={<TablaConsultaCodigoDeCupos
                  showTitle={false}
                  filtroInicial={filtroInicial}
                  fechaFiltro={fechaFiltro}
                />
                }
              />
              : <div style={{
                color: COLORES.grey.dark,
                fontSize: '1rem',
                width: '100%',
                fontWeight: 'bold'
              }}
              >
                {value}
              </div>
          )
        }
      }
    },
    {
      name: 'cupo',
      label: 'Operacion',
      options: {
        print: false,
        filter: false,
        sort: false,
        viewColumns: false,
        display: !soloConsulta,
        customBodyRender: cupo => {
          if (cupo.vigente) {
            return <OperacionesCupoNominado cupo={cupo} />
          } else {
            return <></>
          }
        }
      }
    }
  ]
  return columnas
}

export const CUPOS_NOMINADOS_TO_PRINT = [
  {
    name: 'exportador',
    label: 'Exportador',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'fechaDeEmisionDate',
    label: 'Fecha de cupo',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cargador',
    label: 'Titular de cupo',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'corredor',
    label: 'Corredor de cupo',
    width: 90,
    mantenerCase: true
  },
  {
    name: 'cantidadAsignada',
    label: 'Nominados',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cantidadUsada',
    label: 'Usados',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cantidadDisponible',
    label: 'Disponibles',
    width: 50,
    mantenerCase: true
  }
]
